import { SIGN_OUT } from 'Global/Stores/auth'

const RESERVATION_CREATE = 'API|RESERVATION/CREATE_'
export const RESERVATION_CREATE_FULFILLED = `FULFILLED_${RESERVATION_CREATE}`
const RESERVATION_CREATE_PENDING = `PENDING_${RESERVATION_CREATE}`
const RESERVATION_CREATE_REJECTED = `REJECTED_${RESERVATION_CREATE}`

const RESERVATION_DELETE = 'API|RESERVATION/DELETE'
export const RESERVATION_DELETE_FULFILLED = `FULFILLED_${RESERVATION_DELETE}`
const RESERVATION_DELETE_PENDING = `PENDING_${RESERVATION_DELETE}`
const RESERVATION_DELETE_REJECTED = `REJECTED_${RESERVATION_DELETE}`

const RESERVATION_EDIT = 'API|RESERVATION/EDIT'
export const RESERVATION_EDIT_FULFILLED = `FULFILLED_${RESERVATION_EDIT}`
const RESERVATION_EDIT_PENDING = `PENDING_${RESERVATION_EDIT}`
const RESERVATION_EDIT_REJECTED = `REJECTED_${RESERVATION_EDIT}`

/**
 * POST request to the API to create a reservation.
 * @param {object} reservation - Reservation object.
 * @returns {object} Action object.
 */
export const reservationCreate = reservation => ({
  meta: {
    data: { reservation },
    method: 'post',
    successMessage: `Reservation created.`,
    url: '/api/v1/reservations',
  },
  type: RESERVATION_CREATE,
})

/**
 * DELETE request to the API to delete a reservation.
 * @param {Object} reservation - Reservation object.
 * @param {number} user - User ID.
 * @returns {Object} Action object.
 */
export const reservationDelete = (reservation, user) => ({
  meta: {
    data: { reservation, user },
    method: 'delete',
    successMessage: `Reservation deleted.`,
    url: '/api/v1/reservations',
  },
  type: RESERVATION_DELETE,
})

/**
 * PATCH request to the API to edit a reservation.
 * @param {object} reservation - Reservation object.
 * @param {object} user - User object.
 * @returns {object} Action object.
 */
export const reservationEdit = (reservation, user) => ({
  meta: {
    data: { reservation, user },
    method: 'patch',
    successMessage: `Reservation updated.`,
    url: '/api/v1/reservations',
  },
  type: RESERVATION_EDIT,
})

const initialState = {
  error: false,
  pending: false,
}

const reducer = (state = initialState, action) => {
  const { type } = action

  switch (type) {
    case RESERVATION_CREATE_FULFILLED:
      return {
        ...state,
        error: false,
        pending: false,
      }

    case RESERVATION_CREATE_PENDING:
      return {
        ...state,
        error: false,
        pending: true,
      }

    case RESERVATION_CREATE_REJECTED:
      return {
        ...state,
        error: true,
        pending: false,
      }

    case RESERVATION_DELETE_FULFILLED:
      return {
        ...state,
        error: false,
        pending: false,
      }

    case RESERVATION_DELETE_PENDING:
      return {
        ...state,
        error: false,
        pending: true,
      }

    case RESERVATION_DELETE_REJECTED:
      return {
        ...state,
        error: true,
        pending: false,
      }

    case RESERVATION_EDIT_FULFILLED:
      return {
        ...state,
        error: false,
        pending: false,
      }

    case RESERVATION_EDIT_PENDING:
      return {
        ...state,
        error: false,
        pending: true,
      }

    case RESERVATION_EDIT_REJECTED:
      return {
        ...state,
        error: true,
        pending: false,
      }

    case SIGN_OUT:
      return initialState

    default:
      return state
  }
}

export default reducer
